import { cn } from '@shared/utils/utils';

interface IntegrationLogoProps {
  logo: string;
  name: string;
  className?: string;
  'data-testid'?: string;
}

export function IntegrationLogo({ logo, name, className, 'data-testid': dataTestId }: IntegrationLogoProps) {
  return (
    <div
      className={cn(
        'flex h-9 shrink-0 items-center overflow-hidden',
        '[&_svg]:block [&_svg]:!h-9 [&_svg]:!w-auto [&_svg]:max-w-[140px]',
        '[&_img]:block [&_img]:!h-9 [&_img]:!w-auto [&_img]:max-w-[140px]',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: logo }}
      aria-label={name}
      role="img"
      data-testid={dataTestId}
    />
  );
}
